import EnterExam from "../../component/azmoon-list/EnterExam";
import { useParams } from "react-router-dom";
import MobileEnterExam from "../../component/mobile/azmoon-list/M_EnterExam";

const ENTER_EXAM = () => {
  const { id } = useParams();

  return (
    <div className="ENTER_EXAM">
      {window.innerWidth > 1000 && <EnterExam ID={id} />}
      {window.innerWidth < 1000 && <MobileEnterExam ID={id} />}
    </div>
  );
};

export default ENTER_EXAM;
